import { t, useStoreLanguage } from "../../features/store-language/i18n.ts";
import "./LoadingRing.css";

export function PendingRing({ className = "" }) {
  return (
    <span
      className={`pending-ring ${className}`.trim()}
      aria-hidden="true"
    />
  );
}

export default function LoadingRing({ tip, overlay = false, size = "default", className = "" }) {
  useStoreLanguage();
  const message = tip === undefined ? t("در حال آماده سازی داده ها") : tip;

  return (
    <div
      className={`loading-ring${overlay ? " loading-ring--overlay" : ""} loading-ring--${size} ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-label={message || t("در حال آماده سازی داده ها")}
    >
      <span className="loading-ring__circle" aria-hidden="true" />
      {message ? <span className="loading-ring__text">{message}</span> : null}
    </div>
  );
}
